import type { StatusNotificationSummary } from '@/api/Rover/notifications/roverNotifications.types';

export type ApplicationFormStatusCatalogItem = {
  code: string;
  label: string;
  isTerminal: boolean;
};

export const notificationHighlightStorageKey = (applicationFormId: string) => `rover.notificationHighlightStatus:${applicationFormId}`;

/** Client-only id until GET /notifications returns real FormStatus ids. */
export const staticStatusKey = (code: string) => `static:${code}`;

export const isStaticStatusKey = (status: string) => status.startsWith('static:');

export const staticStatusCodeFromKey = (status: string) => (status.startsWith('static:') ? status.slice('static:'.length) : null);

export const staticStatusLabelFromKey = (status: string, catalog: ApplicationFormStatusCatalogItem[]) => {
  const code = staticStatusCodeFromKey(status);
  return catalog.find((s) => s.code === code)?.label ?? status;
};

export function buildSummariesFromStatusCatalog(catalog: ApplicationFormStatusCatalogItem[]): StatusNotificationSummary[] {
  return catalog.map(({ code, label }) => ({
    status: staticStatusKey(code),
    statusLabel: label,
    source: 'default',
    enabled: { email: true, sms: true, onscreen: true },
    messageType: { email: 'default', sms: 'default', onscreen: 'default' },
    activeOptionCount: 0,
  }));
}

export function resolveStatusLabelFromApplicationCode(
  code: string | null | undefined,
  catalog: ApplicationFormStatusCatalogItem[]
): string | null {
  if (!code) return null;
  return catalog.find((s) => s.code === code)?.label ?? null;
}
